// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3OyWr","upload":"Small_upload__1hKQt","imageWrap":"Small_imageWrap__Ktdsn","removeBtn":"Small_removeBtn__3oK_Y"};